module.exports = __webpack_public_path__ + "img/Respond.556a0dd1.png";